/*eslint-disable */
var $ = window.jQuery = require('jquery');
export default {
name: 'users-log-list',
components: {
},
props: [],
data () {
  return {
    allUserLogList:null,
    allUserLogListResults:[]
  }
},
computed: {
},
mounted () {
  this.$store.dispatch('getAllUserOnlineTimeCountApiUrlFun').then((res) => {
    this.allUserLogList = res.data
    this.allUserLogListResults = this.allUserLogList.data
  })
},
methods: {
  secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " Hour, " : " Hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " Min, " : " Mins, ") : "";
      var mODisplay = m > 0 ? m + (m == 1 ? " Min " : " Mins ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " Sec" : " Secs") : "";
    if(hDisplay){
      return hDisplay + mODisplay; 
    }else{
      return mDisplay + sDisplay; 
    }
  },
},
watch: {
},
}